import { render, staticRenderFns } from "./BookingWidget.vue?vue&type=template&id=d2aada66"
import script from "./BookingWidget.vue?vue&type=script&lang=js"
export * from "./BookingWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports